"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADAPTABLE_STATUS_PANEL = void 0;
/**
 * Name of the component specified in AG Grid gridOptions.statusBar.statusPanels
 */
exports.ADAPTABLE_STATUS_PANEL = 'AdaptableStatusPanel';
